export const locales = [
  {
    key: 'en',
    label: 'English',
  },
  {
    key: 'es',
    label: 'Español',
  },
  {
    key: 'de',
    label: 'Deutsch',
  },
  {
    key: 'fr',
    label: 'Français',
  },
  {
    key: 'pt',
    label: 'Português',
  },
  {
    key: 'ru',
    label: 'Русский',
  },
  {
    key: 'tr',
    label: 'Türkçe',
  },
  {
    key: 'uk',
    label: 'українська',
  },
]
